import React from 'react'
import { connect } from 'react-redux'
import { lower } from 'change-case'
import { Field, getFormValues } from 'redux-form'
import { Fade } from '@material-ui/core'
import { StdCard } from 'components'
import { ProcurementBody } from 'routes/ProcurementSystem/styled'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { DPContainer } from './styled'


const RequestInformation = props => {
  const { members } = props

  return (
    <Fade in={true} timeout={1000}>
      <ProcurementBody>
        <StdCard title="Request Information :" >
          <DPContainer>
            <div className="rowFields">
              <Field
                name="title"
                label="Title (Request for)"
                type={type.text}
                editable={false}
                component={FieldInput}
                tooltip
              />
              <Field
                name="requesterName"
                label="Requester"
                component={FieldInput}
                allowAdditions={false}
                loading={members.loading}
                options={members.map(m => ({
                  value: lower(m.username),
                  text: `${m.firstnameEn} ${m.lastnameEn}`,
                }))}
                type={type.text}
                editable={false}
              />
            </div>
            <div className="rowFields">
              <Field
                name="projectName"
                label="Project Name"
                type={type.text}
                editable={false}
                component={FieldInput}
              />
              <Field
                name="documentDate"
                label="Document Date"
                type={type.date}
                editable={false}
                component={FieldInput}
                dateFormat='dd MMM yyyy HH:mm'
              />
            </div>
            <div className="rowFields">
              <div style={{ display: 'flex', flex: '1' }}></div>
              <div className="rowFields">
                <Field
                  name="submittedDate"
                  label="Submitted Date"
                  type={type.date}
                  editable={false}
                  component={FieldInput}
                  dateFormat='dd MMM yyyy HH:mm'
                />
                <Field
                  name="modifiedDate"
                  label="Modified Date"
                  type={type.date}
                  editable={false}
                  dateFormat='dd MMM yyyy HH:mm'
                  component={FieldInput}
                />
              </div>
            </div>
          </DPContainer>
        </StdCard>
      </ProcurementBody>
    </Fade>
  )
}


const mapStateToProps = state => {
  const valueForm = getFormValues('formDP')(state) || {}
  var projectOptions = []
  if (valueForm.companyCode && state.goa.projects && state.goa.projects[valueForm.companyCode]) {
    projectOptions = state.goa.projects[valueForm.companyCode].map(p => {
      return { value: p.id, text: p.projectName }
    })

    if (state.goa.projects.other) {
      state.goa.projects.other.forEach(p => {
        projectOptions.push({ value: p.id, text: p.projectName })
      })
    }
  }
  return {
    dpDetail: state.downPayment.downPaymentDetail.data,
    goaWorkFlow: state.downPayment.goaWorkFlow,
    members: state.member.members,
    companies: state.options.companies,
    valueForm,
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(RequestInformation)



